import { render, staticRenderFns } from "./TeamHeader.vue?vue&type=template&id=7fee74a8"
import script from "./TeamHeader.vue?vue&type=script&lang=js"
export * from "./TeamHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports